// Backwards-compatible wrapper — delegates to the custom theme store
import { useCustomThemeStore } from './theme-custom.store';

type Theme = 'light' | 'dark' | 'system';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useThemeStore = (): ThemeState => {
  const { customTheme, updateMode } = useCustomThemeStore();
  return {
    theme: customTheme.mode,
    setTheme: (theme: Theme) => updateMode(theme),
  };
};
